import { StyleSheet } from "react-native";



export const theme = {
    
};

export default StyleSheet.create({
    
})